<!--
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2022-11-16 11:00:25
 * @LastEditors: pj
 * @LastEditTime: 2022-11-16 13:54:23
-->
<template>
    <a-modal title="短链查询" :visible="isShow" :confirm-loading="confirmLoading" width="800px" @cancel="handleCancel">
        <a-form-model layout="inline" :model="searchP" ref="ruleForm">
            <a-form-model-item label="短链编码" ref="linkcode" prop="linkcode">
                <a-input :addon-before="buscode" v-model="searchP.linkcode" />
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="handleSubmit">查询</a-button>
            </a-form-model-item>
        </a-form-model>
        <div v-show="cardShow">
            <a-card title="查询结果" :bordered="false">
                <p>
                    <span>
                        链接：
                    </span>
                    <span>
                        {{result.url}}
                    </span>
                </p>
                <p>
                    <span>
                        过期时间：
                    </span>
                    <span>
                        {{result.expiretime}}
                    </span>
                </p>
                <p>
                    <span>
                        创建时间：
                    </span>
                    <span>
                        {{result.createtime}}
                    </span>
                </p>
                <p>
                    <span>
                        更新时间：
                    </span>
                    <span>
                        {{result.updatetime}}
                    </span>
                </p>
            </a-card>
        </div>
        <template slot="footer">
            <a-button key="back" @click="handleCancel">
                取消
            </a-button>
        </template>
    </a-modal>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            searchP: {
                linkcode: '',
            },
            cardShow: false,
            result: {
                url: '',
                expiretime: '',
                createtime: '',
                updatetime: '',
            },
            confirmLoading: false,
            isShow: false,
            buscode: '',
        }
    },
    methods: {
        init(buscode) {
            this.buscode = buscode
            this.isShow = true
        },
        handleCancel() {
            this.result = {
                url: '',
                expiretime: '',
                createtime: '',
                updatetime: '',
            }
            this.isShow = false
            this.cardShow = false
        },
        handleSubmit() {
            // debugger
            let that = this
            let linkcode = that.searchP.linkcode
            if (!linkcode) {
                return
            }
            console.log(linkcode)
            let linkid = linkcode
            this.confirmLoading = true
            that.$store
                .dispatch({
                    type: 'open/queryShortLink',
                    params: { buscode: this.buscode, linkid: linkid },
                })
                .then((res) => {
                    let back = res.data.data
                    if (back) {
                        // url,expiretime,createtime,updatetime
                        if (back.url) {
                            this.result.url = back.url
                            this.result.expiretime = back.expiretime
                            this.result.createtime = back.createtime
                            this.result.updatetime = back.updatetime
                            this.cardShow = true
                        }
                    }
                    this.confirmLoading = false
                })
                .catch(() => {
                    this.confirmLoading = false
                    this.result = {
                        url: '',
                        expiretime: '',
                        createtime: '',
                        updatetime: '',
                    }
                    this.cardShow = false
                })
        },
    },
    mounted() {},
}
</script>

<style>
.myform {
    margin-bottom: 20px;
}
</style>


